import { z } from 'zod';

import { clientSchema } from './client';
import { jobSchema } from './job';
import { locationSchema } from './location';

export const clientDetailSchema = clientSchema.extend({
  locations: z.array(locationSchema),
  jobs: z.array(jobSchema),
});

export const jobDetailSchema = jobSchema.extend({
  client: clientSchema,
  location: locationSchema,
});
